var _rect, _path, _path2, _path3, _path4;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFullScreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 23.9997,
    height: 24,
    rx: 2,
    fill: "#252525",
    fillOpacity: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.6641 6.34277C13.6641 6.75699 13.9999 7.09277 14.4141 7.09277L16.9068 7.09277V9.58541C16.9068 9.99963 17.2426 10.3354 17.6568 10.3354C18.071 10.3354 18.4068 9.99963 18.4068 9.58541V6.34277C18.4068 5.92856 18.071 5.59277 17.6568 5.59277L14.4141 5.59277C13.9999 5.59277 13.6641 5.92856 13.6641 6.34277Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.6567 13.6639C17.2425 13.6639 16.9067 13.9996 16.9067 14.4139L16.9067 16.9065L14.4141 16.9065C13.9999 16.9065 13.6641 17.2423 13.6641 17.6565C13.6641 18.0707 13.9999 18.4065 14.4141 18.4065L17.6567 18.4065C18.071 18.4065 18.4067 18.0707 18.4067 17.6565L18.4067 14.4139C18.4067 13.9996 18.071 13.6639 17.6567 13.6639Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.34304 13.6639C6.75726 13.6639 7.09304 13.9996 7.09304 14.4139L7.09304 16.9065L9.58569 16.9065C9.9999 16.9065 10.3357 17.2423 10.3357 17.6565C10.3357 18.0707 9.9999 18.4065 9.58569 18.4065L6.34304 18.4065C5.92883 18.4065 5.59304 18.0707 5.59304 17.6565L5.59304 14.4139C5.59304 13.9996 5.92883 13.6639 6.34304 13.6639Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.3357 6.34277C10.3357 6.75699 9.99987 7.09277 9.58566 7.09277L7.09302 7.09277L7.09302 9.58541C7.09302 9.99963 6.75723 10.3354 6.34302 10.3354C5.9288 10.3354 5.59302 9.99963 5.59302 9.58541L5.59302 6.34277C5.59302 5.92856 5.92881 5.59277 6.34302 5.59277L9.58566 5.59277C9.99987 5.59277 10.3357 5.92856 10.3357 6.34277Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFullScreen);
export default __webpack_public_path__ + "static/media/full-screen.615717202c37acc14872b6338fae99ce.svg";
export { ForwardRef as ReactComponent };